<template>
  <el-form
    class="bg-white"
    style="padding: 15px"
    label-position="top"
    v-loading="isLoading"
    :rules="rules"
    :model="batch"
  >
    <h4 class="form-title">Batch Information</h4>
    <!-- <el-form-item label="Supplier">
      <el-input
        type="text"
        :readonly="true"
        v-model="inspectionSheet.supplier_name"
      />
    </el-form-item>
    <el-row :gutter="15">
      <el-col :sm="12">
        <el-form-item label="Purchase Order">
          <el-input
            type="text"
            :readonly="true"
            v-model="inspectionSheet.po_no"
          />
        </el-form-item>
      </el-col>
      <el-col :sm="12">
        <el-form-item label="P.O. Date">
          <el-input :readonly="true" v-model="po.po_date"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :sm="12">
        <el-form-item label="Batch No.">
          <el-input type="text" :readonly="true" v-model="batch.batch_no" />
        </el-form-item>
      </el-col>
      <el-col :sm="12">
        <el-form-item label="Invoice No.">
          <el-input :readonly="true" v-model="batch.invoice_no"></el-input>
        </el-form-item>
      </el-col>
    </el-row> -->
    <template v-if="false">
      <el-row :gutter="15" v-if="!currency.sign.includes('AED')">
        <el-col :sm="8">
          <el-form-item
            :label="'Customs Duty (' + currency.sign + ')'"
            prop="customs_duty_foreign"
          >
            <el-input-number
              v-model.number="batch.customs_duty_foreign"
              :disabled="is_readonly"
              :readonly="is_readonly"
              :controls="false"
              :min="0"
              :precision="2"
              @change="convertExpensesToAED"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="8">
          <el-form-item
            :label="'Freight Cost (' + currency.sign + ')'"
            prop="freight_cost_foreign"
          >
            <el-input-number
              v-model.number="batch.freight_cost_foreign"
              :disabled="is_readonly"
              :readonly="is_readonly"
              :controls="false"
              :min="0"
              :precision="2"
              @change="convertExpensesToAED"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="8">
          <el-form-item
            :label="'Other Expenses (' + currency.sign + ')'"
            prop="bank_expenses_foreign"
          >
            <el-input-number
              v-model.number="batch.bank_expenses_foreign"
              :disabled="is_readonly"
              :readonly="is_readonly"
              :controls="false"
              :min="0"
              :precision="2"
              @change="convertExpensesToAED"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </template>
    <el-row :gutter="15">
      <el-col :sm="8">
        <el-form-item label="Customs Duty (AED)" prop="customs_duty">
          <el-input-number
            v-model.number="batch.customs_duty"
            :disabled="is_readonly"
            :readonly="is_readonly"
            :controls="false"
            :min="0"
            :precision="2"
            @change="convertExpensesToFOREIGN"
          />
          <!-- <span v-else>{{ batch.customs_duty | currency }}</span> -->
        </el-form-item>
      </el-col>
      <el-col :sm="8">
        <el-form-item label="Freight Cost (AED)" prop="freight_cost">
          <el-input-number
            v-model.number="batch.freight_cost"
            :disabled="is_readonly"
            :readonly="is_readonly"
            :controls="false"
            :min="0"
            :precision="2"
            @change="convertExpensesToFOREIGN"
          />
        </el-form-item>
      </el-col>
      <el-col :sm="8">
        <el-form-item label="Other Expenses (AED)" prop="bank_expenses">
          <el-input-number
            v-model.number="batch.bank_expenses"
            :disabled="is_readonly"
            :readonly="is_readonly"
            :controls="false"
            :min="0"
            :precision="2"
            @change="convertExpensesToFOREIGN"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-table :data="items">
      <el-table-column v-if="!is_readonly" label="Action" fixed width="60">
        <template slot-scope="scope">
          <el-button
            @click="remove(scope.row)"
            type="danger"
            title="Remove this item."
            circle
            icon="el-icon-delete"
            size="small"
          ></el-button>
        </template>
      </el-table-column>
      <el-table-column label="Part No." fixed prop="part.part_no" width="120" />
      <el-table-column
        label="Description"
        width="200"
        fixed
        prop="part.part_description"
      />
      <el-table-column
        :label="'Unit Price (' + currency.sign + ')'"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.unit_price | currency(currency.sign, 4) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Unit Price (AED)"
        width="120"
        v-if="!currency.sign.includes('AED')"
      >
        <template slot-scope="scope">
          <span>{{ aed_unitprice(scope.row) | currency("AED ", 4) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Quantity" width="120">
        <template slot-scope="scope">
          <el-input-number
            v-model.number="scope.row.quantity"
            :controls="false"
            :min="1"
            v-if="!is_readonly"
          ></el-input-number>
          <span v-else>{{ scope.row.quantity | number("0,0") }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Item Type" width="150">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.item_type"
            v-if="!is_readonly"
            @change="computePrices"
          >
            <el-option
              v-for="type in itemTypes"
              :key="type.value"
              :value="type.value"
              :label="type.label"
            ></el-option>
          </el-select>
          <div v-else><span v-text="scope.row.item_type_desc"></span></div>
        </template>
      </el-table-column>
      <!-- <el-table-column
        :label="'Final Price (' + currency.sign + ')'"
        width="120"
        v-if="!currency.sign.includes('AED')"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.final_price_usd | currency(currency.sign, 2)
          }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="Final Price (USD)" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.final_price_usd | currency("$ ", 4) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="'Final Price (AED)'" width="120">
        <template slot-scope="scope">
          <!-- <span>{{
            scope.row.final_price_aed | currency(supplier.currency.sign, 4)
          }}</span> -->
          <span>{{ scope.row.final_price_aed | currency("AED ", 4) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Date Received" width="160">
        <template slot-scope="scope">
          <el-date-picker
            v-if="!is_readonly"
            v-model="scope.row.date_received"
          ></el-date-picker>
          <span v-else>{{ scope.row.date_received }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Remarks">
        <template slot-scope="scope">
          <el-input
            v-if="!is_readonly"
            type="text"
            v-model="scope.row.remarks"
          ></el-input>
          <span v-else>{{ scope.row.remarks }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="Unit Price" /> -->
    </el-table>
    <div class="mt-2">
      <!-- <label class="el-form-item__label" v-if="!currency.sign.includes('AED')"
        >Total Invoice Amount:
        <b>{{ total_invoice_foreign | currency(currency.sign, 2) }}</b></label
      > -->
      <!-- <label class="el-form-item__label"
        >Total Invoice Amount:
        <b>{{ total_invoice_foreign | currency("$ ", 2) }}</b></label
      ><br /> -->
      <label class="el-form-item__label"
        >Total Invoice Amount:
        <b>{{ total_invoice | currency("AED ", 2) }}</b></label
      ><br />
      <label class="el-form-item__label"
        >Percentage of Expenses Against Total Invoice Amt.:
        <b>{{ expense_percentage + "%" }}</b></label
      >
    </div>
    <div class="mt-3 mb-3">
      <h4 class="text-primary">Attached Documents</h4>
      <DocList></DocList>
    </div>

    <div class="d-flex mt-2">
      <el-upload
        :action="api.href"
        :headers="api.headers"
        accept="application/pdf"
        :data="{ q: 'documents' }"
        :show-file-list="false"
        :on-success="handleUploadSuccess"
        :before-upload="beforeUpload"
        :disabled="is_uploading"
        class="mr-1"
      >
        <el-button size="small" type="primary" :disabled="is_uploading"
          ><i v-if="is_uploading" class="el-icon-loading"></i> Upload</el-button
        >
      </el-upload>
      <el-button
        type="primary"
        size="small"
        @click="save"
        v-if="!is_readonly"
        :disabled="is_uploading"
        >Save</el-button
      >
      <router-link
        v-if="is_readonly"
        :to="{
          name: 'print_barcode',
          params: { id: batch.id }
        }"
        target="_blank"
        class="el-button el-button--primary el-button--small"
        >Print Barcode</router-link
      >
      <el-button size="small" @click="cancel">Cancel</el-button>
    </div>
  </el-form>
</template>

<script>
import PurchaseOrder from "@/models/PurchaseOrder";
import moment from "moment";
import BatchInfo from "@/models/BatchInfo";
import Currency from "@/models/Currency";
import api from "@/api";
import InspectionSheet from "@/models/InspectionSheet";
import DocList from "./doc-list.vue";
export default {
  name: "BatchInformation",
  components: { DocList },
  computed: {
    api() {
      return {
        headers: {
          // "Content-Type": "multipart/form-data",
          Authorization: `${this.$store.getters["auth/token"].token_type} ${this.$store.getters["auth/token"].access_token}`,
          "X-Requested-With": "XMLHttpRequest"
        },
        href: new URL("/api/v1/inventory/fileupload/", api.baseUrl).href
      };
    },
    inspectionSheet() {
      return this.$store.getters["stockin/inspectionSheet"];
    },
    total_invoice() {
      if (this.items.length) {
        var total = 0;
        for (let item of this.items) {
          if (item.item_type != 2) {
            total += parseFloat(item.unit_price) * parseFloat(item.quantity);
          }
        }
        if (!this.currency.sign.includes("AED")) {
          return total * this.currency.rate;
        } else {
          return total;
        }
      }
      return 0;
    },
    total_invoice_foreign() {
      // if (!this.currency.sign.includes("AED"))
      //   return this.total_invoice / this.currency.rate;
      // else return this.total_invoice / this.foreignCurrency.rate;
      return this.total_invoice / this.foreignCurrency.rate;
    },
    expense_percentage() {
      var val =
        ((parseFloat(this.batch.customs_duty) +
          parseFloat(this.batch.freight_cost) +
          parseFloat(this.batch.bank_expenses)) /
          parseFloat(this.total_invoice)) *
        100;
      if (val) return parseFloat(val).toFixed(3);

      return 0;
    },
    supplier() {
      if (this.po.id) {
        return this.po.supplier;
      }
      return { currency: { sign: "$" } };
    },
    docs() {
      return this.$store.getters["stockin/docs"];
    }
  },
  watch: {
    inspectionSheet(obj) {
      this.isLoading = true;
      if (obj.id) {
        this.batch.batch_no = obj.batch_no;
        this.batch.invoice_no = obj.invoice_no;
        PurchaseOrder.fetch(obj.po_no_id).then(resp => {
          this.po = new PurchaseOrder(resp);
          this.po.po_date = moment(this.po.po_date).format("MM/DD/YYYY");
          this.isLoading = false;
          if (obj.status == 0) {
            // if new batch info
            this.isLoading = true;
            this.currency = {
              currency: resp.currency_rate.currency,
              rate: resp.currency_rate.rate,
              sign: resp.currency_rate.sign.toUpperCase() + " "
            };
            BatchInfo.fetchAvailableItems(obj.po_no_id).then(resp => {
              this.isLoading = false;
              for (let item of resp) {
                this.items.push({
                  ...item,
                  date_received: moment(obj.date_received).format("MM/DD/YYYY"),
                  item_type: 1,
                  remarks: "",
                  final_price_usd: 0,
                  final_price_aed: 0
                });
              }
              this.computePrices();
            });
          } else {
            // if viewing of batch info
            this.is_readonly = true;
            this.isLoading = true;
            PurchaseOrder.fetch(obj.po_no_id).then(resp => {
              this.currency = {
                currency: resp.currency_rate.currency,
                rate: resp.currency_rate.rate,
                sign: resp.currency_rate.sign.toUpperCase() + " "
              };
            });
            BatchInfo.fetch(obj.batch_id).then(resp => {
              this.batch.id = obj.batch_id;
              this.batch.batch_no = obj.batch_no;
              this.batch.invoice_no = obj.invoice_no;
              this.isLoading = false;
              var inv = resp.invoice[0];
              // for (let inv of resp.invoice[0]) {
              this.batch.customs_duty = inv.customs_duty;
              this.batch.freight_cost = inv.freight_cost;
              this.batch.bank_expenses = inv.bank_expenses;
              // this.expense_percentage = inv.percentage;
              // }
              for (let item of resp.items) {
                var itemType = "item_type" in item ? item.item_type : 1;
                this.items.push({
                  ...item,
                  date_received: moment(item.received_at).format("MM/DD/YYYY"),
                  remarks: item.remarks,
                  item_type: itemType,
                  item_type_desc: this.itemTypes.find(o => {
                    return o.value == itemType;
                  }).label,
                  unit_price: item.po.unit_price,
                  final_price_usd: item.final_price_usd,
                  final_price_aed: item.final_price_aed
                });
              }
              this.convertExpensesToFOREIGN();
            });
          }
        });
      }

      // this.batch = new BatchInfo(obj);
    },
    expense_percentage() {
      if (!this.is_readonly) this.computePrices();
    }
  },
  data() {
    return {
      isLoading: false,
      items: [],
      po: new PurchaseOrder(),
      batch: new BatchInfo(),
      rules: BatchInfo.rules(),
      is_readonly: false,
      itemTypes: [
        { value: 1, label: "Purchased" },
        { value: 2, label: "Salvaged" },
        { value: 3, label: "Consignment" }
      ],
      currency: {
        sign: "USD",
        rate: 1
      },
      localCurrency: {},
      foreignCurrency: {},
      is_uploading: false
    };
  },
  mounted() {
    this.getCurrency();
  },
  methods: {
    convertExpensesToAED() {
      this.batch.customs_duty =
        this.batch.customs_duty_foreign * this.currency.rate;
      this.batch.freight_cost =
        this.batch.freight_cost_foreign * this.currency.rate;
      this.batch.bank_expenses =
        this.batch.bank_expenses_foreign * this.currency.rate;
    },
    convertExpensesToFOREIGN() {
      this.batch.customs_duty_foreign =
        this.batch.customs_duty / this.currency.rate;
      this.batch.freight_cost_foreign =
        this.batch.freight_cost / this.currency.rate;
      this.batch.bank_expenses_foreign =
        this.batch.bank_expenses / this.currency.rate;
    },
    aed_unitprice(item) {
      if (this.currency.sign != "AED ") {
        item.unit_price_local = item.unit_price * this.currency.rate;
        return item.unit_price_local;
      }
    },
    getCurrency() {
      //   this.localCurrency = this.getCurrency(
      //   this.$store.getters["currency/local"]
      // );
      // this.foreignCurrency = this.getCurrency(
      //   this.$store.getters["currency/foreign"]
      // );
      if (this.$store.getters["currency/local"]) {
        Currency.fetch(this.$store.getters["currency/local"]).then(resp => {
          this.localCurrency = resp;
        });
      }
      if (this.$store.getters["currency/foreign"]) {
        Currency.fetch(this.$store.getters["currency/foreign"]).then(resp => {
          this.foreignCurrency = resp;
        });
      }
    },
    cancel() {
      this.$router.push({ name: "batchcontrol" });
    },
    computePrices() {
      if (this.is_readonly) return false;
      var multiplier = 100;
      if (process.env.VUE_APP_BATCH_PERCENTAGE) {
        multiplier = process.env.VUE_APP_BATCH_PERCENTAGE / 100;
      }
      if (this.items.length) {
        for (let item of this.items) {
          if (item.item_type == 2) {
            item.final_price_usd = 0;
            item.final_price_aed = 0;
          } else {
            if (!this.currency.sign.includes("AED")) {
              // convert to AED values
              item.final_price_aed =
                item.unit_price *
                this.currency.rate *
                (this.expense_percentage / 100 + 1) *
                multiplier;
              if (this.currency.sign.includes("$")) {
                item.final_price_usd =
                  item.unit_price *
                  (this.expense_percentage / 100 + 1) *
                  multiplier;
              } else {
                item.final_price_usd =
                  item.final_price_aed / this.foreignCurrency.rate;
              }
            } else {
              item.final_price_usd =
                (item.unit_price / this.foreignCurrency.rate) *
                (this.expense_percentage / 100 + 1) *
                multiplier;

              item.final_price_aed =
                item.unit_price *
                (this.expense_percentage / 100 + 1) *
                multiplier;
            }
          }
        }
      }
    },
    remove(item) {
      this.$confirm("Are you sure you want to remove this item?", {
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      })
        .then(() => {
          this.items = this.items.filter(o => {
            return o.id != item.id;
          });
        })
        .catch(() => {});
    },
    save() {
      this.$confirm("Are you sure you want to save this batch information?", {
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      })
        .then(() => {
          if (this.docs.length == 0) {
            this.$notify({
              type: "error",
              message:
                "Please upload the certificate, packaging list, invoice, etc.",
              position: "bottom-right"
            });
            return false;
          }

          var data = {
            invoice: { ...this.batch },
            items: []
          };
          delete data.id;
          data.invoice.last_aed_rate = this.localCurrency.rate;
          data.invoice.percentage = this.expense_percentage;
          for (let item of this.items) {
            if (item.quantity <= 0) {
              this.$notify({
                type: "error",
                message: "Item quantity should be more than zero.",
                position: "bottom-right"
              });
            }
            data.items.push({
              po_item_id: item.id,
              quantity: item.quantity,
              remarks: item.remarks,
              item_type: item.item_type,
              date_received: moment(item.date_received).format("YYYY-MM-DD"),
              final_price_usd: parseFloat(item.final_price_usd).toFixed(4),
              final_price_aed: parseFloat(item.final_price_aed).toFixed(4)
            });
          }
          // console.log(data);
          this.isLoading = true;
          BatchInfo.create(data).then(resp => {
            this.isLoading = false;
            if (resp && resp.code == 200) {
              this.$notify({
                type: "success",
                message: "Batch information saved successfully.",
                position: "bottom-right"
              });
              this.$router.push({ name: "batchcontrol" });
            }
          });
        })
        .catch(() => {});
    },
    beforeUpload() {
      this.is_uploading = true;
    },
    handleUploadSuccess(resp) {
      if (resp.data.hasOwnProperty("code") && resp.data.code == 200) {
        // this.docs.push(resp.data.msg);
        var file_dir = resp.data.msg;
        // save after receiving the response
        var data = {
          inspection_id: this.inspectionSheet.id,
          docs: file_dir
          // docs: this.docs.toString()
        };
        InspectionSheet.postDocument(data).then(resp => {
          this.is_uploading = false;
          if (resp.hasOwnProperty("code") && resp.code == 200) {
            this.$notify({
              type: "success",
              message: "File upload successful.",
              position: "bottom-right"
            });
            this.$store.dispatch("stockin/getDocs", this.inspectionSheet.id);
          }
        });
      }
    }
  }
};
</script>
